var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sel-role-wrapper"},[(this.$store.state.user.userInfo.roleType == 0)?_c('role-select'):_vm._e(),_vm._v(" "),(this.$store.state.user.userInfo.roleType == 2)?_c('parent-list'):_vm._e(),_vm._v(" "),(this.$store.state.user.userInfo.roleType == 1)?_c('child-list'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b93502a","hasScoped":true,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/pages/family/RelationShip.vue
// module id = null
// module chunks = 